import { render, staticRenderFns } from "./shiftManagementSettings.vue?vue&type=template&id=0a1836ec&scoped=true"
import script from "./shiftManagementSettings.vue?vue&type=script&lang=js"
export * from "./shiftManagementSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1836ec",
  null
  
)

export default component.exports